import _ from 'underscore';

angular.module('am4')
.directive('elasticListColumn', function($filter, $translate, $timeout, REGEX) {
    return {
        restrict: 'E',
        scope: {
            columnType: '=',
            columnName: '=',
            columnElements: '=',
            checkedInColumn: '=',
            selectionCallback: '=',
            elementLookup: '=',
            cyName: '='
        },
        template: require('./elasticListColumn.html'),
        link: function(scope, element) {
            scope.$watch('columnElements', function(newVal) {
                if (scope.search.active) {
                    filterElements();
                } else {
                    scope.displayElements = newVal;
                }
            });

            scope.search = {
                active: false,
                searchTerm: ''
            };

            scope.getText = function(val) {
                switch (scope.columnType) {
                case 'organization_id': return scope.elementLookup[val] || $translate.instant('UNKNOWN');
                case 'facility_id': return scope.elementLookup[val] || $translate.instant('UNKNOWN');
                case 'machine_type_code': return $translate.instant($filter('uppercase')(val)) || $translate.instant('UNKNOWN');
                case 'series': return $filter('seriesName')(val) || $translate.instant('UNKNOWN');
                case 'status': return $translate.instant(val);
                default: return $translate.instant('UNKNOWN');
                }
            };

            scope.getSearchTerm = function(val) {
                if (scope.columnType === 'organization_id' || scope.columnType === 'facility_id') {
                    return (scope.elementLookup[val] + ' ' + val) || $translate.instant('UNKNOWN');
                }
                return scope.getText(val);

            };

            // All of this madness is due to safari mobile (iOS)
            // requiring element.focus() to be triggered in a touchstart event
            element.find('.am4-filters__header').on('touchstart click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                scope.search.active = !scope.search.active;

                if (scope.search.active) {
                    element.find('input')[0].focus();
                } else {
                    element.find('input')[0].blur();
                    // delete search when deactivating search state
                    scope.search.searchTerm = '';
                    constructRegex();
                    filterElements();
                }

                scope.$apply();
            });

            element.find('input').on('touchstart click', function(e) {
                e.stopPropagation();
            });

            scope.$watch('search.searchTerm', function() {
                constructRegex();
                filterElements();
            });

            function constructRegex() {
                scope.search.searchRegex = new RegExp(scope.search.searchTerm
                    .replace(REGEX.REGEX_CHARACTERS, '\\$&')
                    .split(REGEX.SPACES)
                    .join('.*'), 'i');
            }

            function filterElements() {
                scope.displayElements = _.filter(scope.columnElements, function(val) {
                    return scope.search.searchRegex.test(scope.getSearchTerm(val));
                });
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/elasticListColumn.js